﻿/* Watch an element and trigger a callback when user has scrolled down to it
* Usage: $(element).onviewed(callback);
* Operates on a single element only (first in a jquery collection), use onviewed multiple times to track multiple elements
* Only checks if scrolled down enough, expand if needed
*/
(function ($) {
    var $window = $(window);

    $.fn.onviewed = function (callback) {
        var element = this.eq(0);
        var checkTimeout = null;

        if (!element.length || !callback) {
            return this;
        }

        var check = function() {
            var fold = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
            var inview = fold >= $(element).offset().top;
            if (inview) {
                callback.call();
                $window.off('scroll', checkDelayed);
                clearTimeout(checkTimeout);
            }
        };

        var checkDelayed = function () {
            if (checkTimeout) {
                clearTimeout(checkTimeout);
            }
            checkTimeout = setTimeout(function () {
                check();
            }, 100);
        };

        $window.on('scroll', checkDelayed);

        $(check);

        return this;
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./assets/js/libs/jquery.onviewed.js
// module id = DY1O
// module chunks = 3 4